module.exports = __webpack_public_path__ + "img/obstacle-puce.4b9d9c1f.png";